import React, { useEffect, useState } from 'react';
import QuoteStore from '../../stores/QuoteStore';
import { Button, Row, Modal, Col, Divider, message, Tooltip } from 'antd';
import { ArrowRightOutlined, FileUnknownOutlined, RightOutlined, WarningTwoTone } from '@ant-design/icons';
import { Price } from '@partsbadger/library';
import ErrorRender from '../../components/shared/ErrorRender';

import EditQuoteLineItems from '../../components/Parts/EditQuoteLineItems';

import SalesOrderStore from '../../stores/SalesOrderStore';
import UserStore from '../../stores/UserStore';

import { useHistory } from 'react-router-dom';

import { QuoteLineItemProps, IParts } from '../../types/types';

interface ICosts {
    subTotal: number;
}

interface IParams {
    master_product: number;
}

interface IOrderItems {
    id: number | undefined;
    quantity: number;
    name: string;
    product_description?: string;
    unit_price: string;
}

interface IPartQuotesProps {
    id: number;
    part_data: IParts;
    text?: string;
}

interface IUpdateQuantityProps {
    quote_id: number;
    quantity: number;
    unit_price: string;
    total_price: string;
}

const PartQuotes: React.FC<IPartQuotesProps> = ({ id, part_data, text }) => {
    const [quotes, setQuotes] = useState<QuoteLineItemProps[]>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectQuotes, setSelectQuotes] = useState<QuoteLineItemProps[]>([]);
    const [costs, setCosts] = useState<ICosts>({ subTotal: 0 });
    const [quoteToUpdate, setQuoteToUpdate] = useState<IUpdateQuantityProps>();

    const [errors, setErrors] = useState<any>();

    const history = useHistory();

    useEffect(() => {
        async function loadQuoteLineItems() {
            setLoading(true);

            const params: IParams = {
                master_product: id,
            };

            try {
                const response = await QuoteStore.getQuoteLineItemsByMasterId(params);
                setQuotes(response.results.filter((item: QuoteLineItemProps) => item.quote_related.completed));
                setLoading(false);
            } catch (err) {
                console.log('QuoteStore Error:', err);
                setLoading(false);
            }
        }
        loadQuoteLineItems();
    }, []);

    const goCheckoutPage = () => {
        let order_items: {
            quantity: number;
            name: string;
            quote_has_product?: number;
            product_description: string;
            unit_price: string;
        }[] = [];

        selectQuotes.map((item: IOrderItems) => {
            quotes.map(
                q_item =>
                    q_item.id === item.id &&
                    (order_items = [
                        {
                            name: q_item.name,
                            product_description: '',
                            quote_has_product: q_item.id,
                            quantity: q_item.quantity,
                            unit_price: q_item.unit_price,
                        },
                        ...order_items,
                    ])
            );
        });

        if (order_items.length == 0) {
            message.error('Please, select one quote before proceeding to checkout!');
            return;
        }

        if (!UserStore.user?.default_contact?.id) {
            message.error('No contact provided');
            return;
        }

        const payload = {
            contact: UserStore.user.default_contact.id,
            line_items: order_items,
        };

        SalesOrderStore.createOrderDraft(payload).then(order => {
            history.push(`/my-account/orders/checkout/${order.id}/`);
        });
    };

    async function handleSelectItems(checked: boolean, quote_id: number) {
        if (checked) {
            const quoteSelected = quotes?.filter(item => {
                if (item.id === quote_id) {
                    setCosts({
                        subTotal: costs.subTotal + parseFloat(item.total_price),
                    });
                    return item;
                }
            });

            return setSelectQuotes([...selectQuotes, ...quoteSelected]);
        }

        // Remove quote
        const removeUnselected = selectQuotes.filter(item => {
            if (item.id === quote_id) {
                quotes.map(
                    q_item =>
                        q_item.id === item.id &&
                        setCosts({
                            subTotal: costs.subTotal - parseFloat(q_item.total_price),
                        })
                );
            }
            return item.id != quote_id;
        });

        setSelectQuotes(removeUnselected);
    }

    useEffect(() => {
        async function updateQuotes() {
            if (quoteToUpdate) {
                const updated = quotes.map(item => {
                    if (item.id === quoteToUpdate.quote_id) {
                        selectQuotes?.filter(selec_item => {
                            if (selec_item.id === quoteToUpdate.quote_id) {
                                setCosts({
                                    subTotal:
                                        costs.subTotal -
                                        parseFloat(item.total_price) +
                                        parseFloat(quoteToUpdate.total_price),
                                });

                                return item;
                            }
                        });

                        return {
                            ...item,
                            quantity: quoteToUpdate.quantity,
                            unit_price: quoteToUpdate.unit_price,
                            total_price: quoteToUpdate.total_price,
                        };
                    }

                    return item;
                });

                setQuotes(updated);
            }
        }

        updateQuotes();
    }, [quoteToUpdate]);

    const updateQuantity = async ({ quote_id, quantity, unit_price, total_price }: IUpdateQuantityProps) => {
        setQuoteToUpdate({ quote_id, quantity, unit_price, total_price });
    };

    return (
        <>
            {/*<Tooltip*/}
            {/*    title={*/}
            {/*        quotes.length === 0*/}
            {/*            ? 'Apologies, but it seems that there are no completed quotes available for this part, which is necessary to proceed with the order.'*/}
            {/*            : false*/}
            {/*    }*/}
            {/*>*/}
            {/*    <Button*/}
            {/*        type="primary"*/}
            {/*        size="middle"*/}
            {/*        onClick={() => setVisible(!visible)}*/}
            {/*        loading={loading}*/}
            {/*        disabled={*/}
            {/*            // If all are cancelled, setDisableOrderNow(true) will be executed.*/}
            {/*            quotes.length === 0 || quotes.every(item => item.quote_related.cancelled)*/}
            {/*        }*/}
            {/*    >*/}
            {/*        {text ? text : <>Order Part</>}*/}
            {/*    </Button>*/}
            {/*</Tooltip>*/}

            <Modal
                open={visible}
                title="Order Part"
                onOk={() => setVisible(false)}
                onCancel={() => setVisible(false)}
                width={780}
                bodyStyle={{ overflowY: 'scroll', overflowX: 'auto', height: '60vh' }}
                footer={[
                    <div key={'footer'} className="flex flex-col w-2/4 ml-auto">
                        <div className="flex justify-between mt-2 pt-4">
                            <span className="font-bold text-xl">Total</span>
                            <span className="font-bold text-xl">
                                <Price value={costs.subTotal} />
                            </span>
                        </div>
                        <div className="flex justify-end mt-2">
                            <Button key="back" onClick={() => setVisible(false)}>
                                Close
                            </Button>
                            <Button
                                key="submit"
                                type="primary"
                                loading={loading}
                                onClick={goCheckoutPage}
                                className="flex justify-between items-center"
                                disabled={quotes.length <= 0}
                            >
                                Go To Checkout <ArrowRightOutlined />
                            </Button>
                        </div>
                    </div>,
                ]}
            >
                <div className="flex justify-center items-center">
                    {quotes.length > 0 ? (
                        <>
                            <div
                                className={'2xl:fixed'}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    // backgroundColor: '#9b9595',
                                }}
                            >
                                {part_data?.step_file && part_data.step_file.image ? (
                                    <img
                                        style={{
                                            width: '190px',
                                            height: '170px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                        src={part_data.step_file.image}
                                    />
                                ) : (
                                    <FileUnknownOutlined
                                        style={{
                                            fontSize: '120px',
                                            display: 'flex',
                                            // marginTop: 'auto',
                                            justifyContent: 'center',
                                        }}
                                    />
                                )}
                                <div
                                    className="font-bold"
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        // justifyContent: 'center',
                                        alignItems: 'center',
                                        paddingTop: '4px',
                                    }}
                                >
                                    <span style={{ fontSize: '12px', color: '#9e9d9d' }}>{part_data.name}</span>
                                </div>
                            </div>

                            <div className="flex flex-col w-full">
                                <div className={'subheader'}>
                                    <div className={'my-4'}>
                                        <h3 style={{ textAlign: 'center', fontWeight: 'bold', color: '#c00' }}>
                                            Please add a quote to the order before checkout...
                                        </h3>
                                    </div>
                                </div>
                                <div className="flex flex-col justify-center w-full">
                                    {quotes?.map(q_item => {
                                        return (
                                            <div key={q_item.id}>
                                                <EditQuoteLineItems
                                                    quote_data={q_item}
                                                    handleAdd={isCheck => {
                                                        handleSelectItems(isCheck, q_item.id);
                                                    }}
                                                    handleSave={({ quantity, unit_price, total_price, lead_time }) => {
                                                        //  Todo: update local state

                                                        updateQuantity({
                                                            quote_id: q_item.id,
                                                            quantity,
                                                            unit_price,
                                                            total_price,
                                                        });
                                                    }}
                                                />
                                                <Divider />
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className={'subheader'}>
                            <div className={'flex w-full m-auto justify-center flex-col items-center my-4 text-center'}>
                                <WarningTwoTone style={{ fontSize: '40px', color: '#c00' }} twoToneColor="#c00" />
                                <h3 className="pt-1" style={{ fontSize: '14px', fontWeight: 'bold', color: '#c00' }}>
                                    Sorry, unfortunately, this part doesn't have quotes completed.
                                </h3>
                            </div>
                        </div>
                    )}
                    {errors && <ErrorRender error={errors} />}
                </div>
            </Modal>
        </>
    );
};

export default PartQuotes;
